import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";

import {
  toggleStep,
  handleContactId
} from "../../../../store/actions/multiplos-actions";
import StyledButton from "../../button";
import api from "../../../../services/api";
import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  Content,
  PhonesContainer,
  PhoneSelect,
  PhoneLabel,
  PhoneInput,
  ButtonContainer,
  Button,
  ViewMoreText
} from "../styles";

class SelectPhone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      phones: [],
      contactId: null,
      contact: null,
      offset: 0,
      hideViewMore: false
    };
  }

  componentDidMount() {
    this.requestGetUserPhones();
  }

  requestGetUserPhones = () => {
    this.setState({ loading: true });
    const { userId, user, document } = this.props;
    api
      .get(
        `industrial/customer/v1/users/${userId}/contacts?contactType=PHONE&_offset=0&customerCode=${user}&document=${document}&limit=10000`
      )
      .then(res => {
        this.setState({ loading: false });
        const response = res.data;
        if (response.length != 0) {
          this.setState({ phones: response });
        } else {
          this.props.dispatch(toggleStep(3));
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  };

  handleUserResponse = () => {
    const { contactId, contact } = this.state;
    if (contactId && contact) {
      this.props.dispatch(toggleStep(4));
      this.props.dispatch(handleContactId(contactId, contact));
    } else {
      this.props.dispatch(toggleStep(3));
    }
  };

  render() {
    const { close, back } = this.props;
    const { phones, loading, hideViewMore, contactId } = this.state;
    return (
      <Container>
        <Header>
          <Left>
            {back ? (
              <BackButton
                title="Fechar"
                className="mdi mdi-arrow-left"
                onClick={() => this.props.dispatch(toggleStep(1))}
              />
            ) : null}
            <Title>Vincular Novo Contrato</Title>
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <Content>
          Nâo encontramos seu e-mail vinculado ao contrato informado.
        </Content>
        <br />
        <br />
        <Content>
          Selecione um celular abaixo para o envio do código de validação:
        </Content>
        <PhonesContainer>
          <PhoneSelect className="radio">
            <PhoneLabel>
              <PhoneInput
                type="radio"
                value="nenhuma"
                onClick={() =>
                  this.setState({ contactId: null, contact: null })
                }
                checked={contactId === null ? true : false}
              />
              Nenhuma das opções
            </PhoneLabel>
          </PhoneSelect>
          {phones.map(item => {
            return (
              <PhoneSelect key={item.contact} className="radio">
                <PhoneLabel>
                  <PhoneInput
                    type="radio"
                    value={item.contactId}
                    onClick={() =>
                      this.setState({
                        contactId: item.contactId,
                        contact: item.contact
                      })
                    }
                    checked={contactId === item.contactId ? true : false}
                  />
                  {item.contact}
                </PhoneLabel>
              </PhoneSelect>
            );
          })}
        </PhonesContainer>
        <ButtonContainer>
          <Button>
            <StyledButton
              className="mt-4"
              block
              type="submit"
              icon="account-plus"
              text="Confirmar"
              loading={loading}
              disabled={loading}
              color="#F0B01B"
              onClick={() => this.handleUserResponse()}
            />
          </Button>
        </ButtonContainer>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  userId: state.multiplosReducer.userId,
  user: state.multiplosReducer.user,
  document: state.multiplosReducer.document
});

export default connect(mapStateToProps)(SelectPhone);
